<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import { useI18n } from 'vue-i18n';

import SectionLayout from './SectionLayout.vue';

const { t } = useI18n();
const route = useRoute();
const { currentAccount } = useAccount();

const getAccountId = computed(() => {
  if (currentAccount.value?.id != null) {
    return String(currentAccount.value.id);
  }
  const fromRoute = route.params.accountId;
  return fromRoute != null && fromRoute !== '' ? String(fromRoute) : '';
});
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.NOTE')"
    with-border
  >
    <woot-code :script="getAccountId" />
  </SectionLayout>
</template>
